type ErrorService = string;

interface LoggerInput {
  service: ErrorService;
  level: 'ERROR' | 'WARN' | 'INFO';
  body: any;
}

export const logger = ({ service, level, body }: LoggerInput) => {
  const output = JSON.stringify({ service, level, ...body });

  switch (level) {
    case 'ERROR':
      console.error(output);
      break;
    case 'WARN':
      console.warn(output);
      break;
    default:
      console.log(output);
      break;
  }
};
